import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
// pages
import Demo from '../pages/auth/Demo';
// hooks
import useAuth from '../hooks/useAuth';
// routes
import { PATH } from '../routes/paths';
// utils
import { axiosInstance as axios, setSession } from '../utils/axios';

// ----------------------------------------------------------------------

AppGuard.propTypes = {
  children: PropTypes.node,
};

export default function AppGuard({ children }) {
  const { user } = useAuth();

  if (user.demoable) return <Demo />;
  if (user.businesses.length === 0) return <Navigate to={PATH.management.settings.subscription} />;
  if (user.business === null) return <Navigate to={PATH.management.settings.subscription} />;
  if (user.business && ['draft', 'valid'].includes(user.state)) {
    if (user.business.is_owner) {
      if (user.business.state === 'suspend') {
        return <Navigate to={PATH.management.settings.subscription} />;
      }
      if (user.business.subscription_payment.need_payment) {
        if (window.isNativeApp) {
          return <Navigate to={PATH.management.settings.subscription} />;
        }
        if (user.business.subscription_payment.trial) {
          return <Navigate to={PATH.management.subscription.root} />;
        }
        return <Navigate to={PATH.management.subscription.root} />;
      }
    }
    if (user.business.state === 'suspend' || user.business.subscription_payment.need_payment) {
      return <Navigate to={PATH.management.subscription.suspend} />;
    }
  }
  if (user.business && !axios.defaults.headers['X-Business']) {
    const token = window.localStorage.getItem('token');
    setSession(token, user?.business?.id);
  }
  return <>{children}</>;
}
